import React, { Component } from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';

import LoaderButton from './LoaderButton';
import { authSuccess, getCredentials, logoutUser } from '../actions'
import '../styles/Menu.css';
import { APP_ENVIRONMENT } from "../config/constants";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.restoreCredentials = this.restoreCredentials.bind(this);
  }

  componentDidUpdate(prevProps) {
  if(
    (this.props.authState &&                 // prop exists and
    this.props.authState.isAuthenticated) && // prop is true and
    ((prevProps.authState &&                 // previous prop existed and
    !prevProps.authState.isAuthenticated) ||// previous prop was false
    !prevProps.authState)) {               // or previous prop did not exist
      this.restoreCredentials();
   }
  }

  login() {
    this.props.oktaAuth.signInWithRedirect();
  }

  logout() {
    this.props.oktaAuth.signOut('/');
  }

  async restoreCredentials() {
    const { oktaAuth, dispatch } = this.props;
    dispatch(authSuccess());
    dispatch(getCredentials(await oktaAuth.getIdToken(), await oktaAuth.getUser()));
  }

  getAvailableLinks() {
    return (
      <Nav>
        <LinkContainer to="/" exact={true}><NavItem>Home</NavItem></LinkContainer>
        {this.props.isAuthenticated &&
          <LinkContainer to="/applications"><NavItem>Applications</NavItem></LinkContainer>
        }
      </Nav>
    )
  }

  getUser() {
    if(this.props.isLoginComplete && this.props.userSet)
      return (
        <Navbar.Text pullRight>
          Hello, {this.props.newUser || !this.props.user.complete ? 'New User' : this.props.user.name.displayName}
        </Navbar.Text>
      );
    else
      return null;
  }

  getLoginOrLogout() {
    const AuthButton = (props) => {
      return (
        <Navbar.Form pullRight>
          <LoaderButton
            block
            isLoading={props.isLoading}
            text={props.text}
            glyph={props.glyph}
            loadingText={props.loadingText}
            onClick={props.onClick}
          />
        </Navbar.Form>
      )
    };

    if(this.props.isLoginComplete){
      return (
        <AuthButton
          onClick={this.logout}
          glyph="log-out"
          text="Log Out"
          loadingText="Logging Out..." />
      );
    } else {
      return (
        <AuthButton
          onClick={this.login} // was loginUser()
          glyph="log-in"
          text="Log In"
          loadingText={ this.props.isAuthenticated ? "Getting Credentials..." : "Logging In..."}
          isLoading={this.props.isAuthenticated} />
      );
    }
  }

  render() {
    const dev = APP_ENVIRONMENT === 'dev';
    const title = dev ? 'HS APPLICATIONS TEST ENVIRONMENT' : 'Delta Health Sciences Applications';
    return (
      <Navbar collapseOnSelect inverse={dev}>
        <Navbar.Header>
          <LinkContainer to="/" style={ dev ? { color: 'red' } : null }>
            <Navbar.Brand>
              { title }
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          {this.getAvailableLinks()}
          {this.getLoginOrLogout()}
          {this.getUser()}

        </Navbar.Collapse>
      </Navbar>
    );
  }
}

function mapStateToProps(state) {
  const { auth, appInfo } = state;
  const { user, userSet, isFetching, isAuthenticated, isLoginComplete } = auth;
  const { newUser } = appInfo;
  return {
    isLoginComplete,
    isAuthenticated,
    user,
    userSet,
    newUser,
    isFetching
  };
}

export default connect(mapStateToProps)(withOktaAuth(Menu));